export class PlayerClone {
    constructor(player, orbitAngle) {
        this.player = player;
        this.orbitAngle = orbitAngle;
        this.orbitRadius = 70;
        this.orbitSpeed = 0.025;
        this.x = player.x;
        this.y = player.y;
        this.size = player.size * 0.8;
        this.damage = player.damage * 0.7;
        this.shootCooldown = 0;
        this.shootMaxCooldown = 30;
        this.duration = 8000;
        this.endTime = Date.now() + this.duration;
    }

    isAlive() {
        return Date.now() < this.endTime;
    }

    update() {
        this.orbitAngle += this.orbitSpeed;
        this.x = this.player.x + Math.cos(this.orbitAngle) * this.orbitRadius;
        this.y = this.player.y + Math.sin(this.orbitAngle) * this.orbitRadius;
        if (this.shootCooldown > 0) this.shootCooldown--;
    }

    shoot(enemies) {
        if (this.shootCooldown > 0 || enemies.length === 0) return null;

        let nearest = null;
        let minDist = Infinity;
        for (const e of enemies) {
            if (e.frozenUntil && Date.now() < e.frozenUntil) continue;
            const dx = e.x - this.x;
            const dy = e.y - this.y;
            const d = dx * dx + dy * dy;
            if (d < minDist) { minDist = d; nearest = e; }
        }
        if (!nearest || minDist > 400 * 400) return null;

        this.shootCooldown = this.shootMaxCooldown;
        const dx = nearest.x - this.x;
        const dy = nearest.y - this.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        return { x: this.x, y: this.y, vx: (dx / dist) * 6, vy: (dy / dist) * 6, damage: this.damage };
    }

    draw(ctx) {
        const remaining = this.endTime - Date.now();
        const baseAlpha = Math.min(0.75, remaining / 2000);

        ctx.save();
        ctx.globalAlpha = baseAlpha;
        ctx.shadowBlur = 18;
        ctx.shadowColor = '#00d9ff';
        ctx.fillStyle = '#00d9ff';

        // Draw clone body (same shape as player but tinted)
        const s = this.size;
        ctx.fillRect(this.x - s / 2, this.y - s / 2, s, s);

        // Timer arc around clone
        const progress = Math.max(0, remaining / this.duration);
        ctx.globalAlpha = baseAlpha * 0.6;
        ctx.strokeStyle = '#ffffff';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.arc(this.x, this.y, s + 4, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * progress);
        ctx.stroke();

        ctx.restore();
    }
}
